import { actions } from './actions'

const initialState = {
  fechasSenaladas: {
    data: [],
    loading: false,
    error: '',
  },
  fechaSenalada: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function fechaSenaladasReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FECHAS_SENALADAS_LOAD_REQUESTED:
      return { ...state, fechasSenaladas: { ...state.fechasSenaladas, loading: true } }
    case actions.FECHAS_SENALADAS_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasSenaladas: { ...state.fechasSenaladas, data: action.payload, loading: false },
      }
    case actions.FECHAS_SENALADAS_LOAD_FILED:
      return {
        ...state,
        fechasSenaladas: { ...state.fechasSenaladas, loading: false, error: action.error },
      }
    case actions.FECHA_SENALADA_DELETE_REQUESTED:
      return {
        ...state,
        fechasSenaladas: { ...state.fechasSenaladas, loading: true, error: '' },
      }
    case actions.FECHA_SENALADA_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasSenaladas: {
          ...state.fechasSenaladas,
          data: state.fechasSenaladas.data.filter(fechaS => fechaS.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_SENALADA_DELETE_FILED:
      return {
        ...state,
        fechasSenaladas: { ...state.fechasSenaladas, loading: false, error: action.error },
      }
    case actions.FECHA_SENALADA_UPDATE_REQUESTED:
      return {
        ...state,
        fechasSenaladas: { ...state.fechasSenaladas, loading: true, error: '' },
      }
    case actions.FECHA_SENALADA_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasSenaladas: {
          ...state.fechasSenaladas,
          data: state.fechasSenaladas.data.map(fecS =>
            fecS.id === action.payload.id ? action.payload : fecS,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_SENALADA_UPDATE_FILED:
      return {
        ...state,
        fechasSenaladas: { ...state.fechasSenaladas, loading: false, error: action.error },
      }

    case actions.FECHA_SENALADA_BYID_LOAD_REQUESTED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, loading: true, error: '' },
      }
    case actions.FECHA_SENALADA_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, data: action.payload, loading: false, error: '' },
      }
    case actions.FECHA_SENALADA_BYID_LOAD_FILED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, data: null, loading: false, error: action.error },
      }
    case actions.FECHA_SENALADA_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, data: null, loading: false, error: '' },
      }
    case actions.FECHA_SENALADA_UPDATE_ALL_REQUESTED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, loading: true, error: '' },
      }
    case actions.FECHA_SENALADA_UPDATE_ALL_SUCCEEDED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, data: action.payload, loading: false, error: '' },
      }
    case actions.FECHA_SENALADA_UPDATE_ALL_FILED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, loading: false, error: action.error },
      }
    case actions.FECHA_SENALADA_INSERT_REQUESTED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, loading: true, error: '' },
      }
    case actions.FECHA_SENALADA_INSERT_SUCCEEDED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, data: action.payload, loading: false, error: '' },
      }
    case actions.FECHA_SENALADA_INSERT_FILED:
      return {
        ...state,
        fechaSenalada: { ...state.fechaSenalada, loading: false, error: action.error },
      }
    default:
      return state
  }
}
